export default "__VITE_ASSET__B32bl$6D__"